import type { ComponentPropsWithRef } from "react";

export const AudioFileIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
    <g id="Group_95329" data-name="Group 95329" transform="translate(12209 18575)">
      <g id="Rectangle_41722" data-name="Rectangle 41722" transform="translate(-12209 -18575)" fill="#2a63e9">
        <rect width="64" height="64" stroke="none" />
      </g>
      <g id="Group_95316" data-name="Group 95316" transform="translate(-12197.943 -18564)">
        <path
          id="Path_245113"
          data-name="Path 245113"
          d="M177.873,27.283,165.8,15.213A4.1,4.1,0,0,0,162.937,14h-21.66a4.141,4.141,0,0,0-4.079,4.079v34.36a4.069,4.069,0,0,0,4.079,4.079h33.731a4.069,4.069,0,0,0,4.079-4.079V30.149a4.1,4.1,0,0,0-1.213-2.866Zm-2.315.992H166.63a1.835,1.835,0,0,1-1.819-1.819V17.582Zm-.551,25.873H141.277a1.717,1.717,0,0,1-1.708-1.708V18.078a1.694,1.694,0,0,1,1.708-1.708h21.164V26.456a4.187,4.187,0,0,0,4.189,4.189h10.086V52.439a1.717,1.717,0,0,1-1.708,1.708Z"
          transform="translate(-137.198 -14)"
          fill="#fff"
        />
        <path
          id="Path_245114"
          data-name="Path 245114"
          d="M247.975,257.276l-6.338.822a1.075,1.075,0,0,0-.939,1.056v5.428a3.24,3.24,0,0,0-.528-.059,1.848,1.848,0,1,0,2.171,1.819v-5.37l5.223-.675v3.374a3.237,3.237,0,0,0-.528-.059,1.848,1.848,0,1,0,2.171,1.819v-7.1a1.164,1.164,0,0,0-.352-.792,1,1,0,0,0-.881-.264Z"
          transform="translate(-228.487 -236.295)"
          fill="#fff"
        />
        <g id="Group_95302" data-name="Group 95302" transform="translate(4.287 14.962)">
          <path
            id="Path_245109"
            data-name="Path 245109"
            d="M242.964,239.12A11.684,11.684,0,1,0,254.649,250.8,11.69,11.69,0,0,0,242.964,239.12Zm0,21a9.315,9.315,0,1,1,9.315-9.315A9.338,9.338,0,0,1,242.964,260.119Z"
            transform="translate(-231.28 -239.12)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);
